import InteroperableObj from "../InteroperableObj";
import spendMode from "../spendMode";
import EggSurpise from "../EggSurpise";
import O1HD from "../../../engines/gameEngine";

const {menu,ccclass, property} = cc._decorator;

@ccclass
@menu("游戏中物体/许愿井")
export default class WishWell extends InteroperableObj {

    //许愿井  点击许愿井

    clickCount:number = 0;

    @property({type:cc.Node,displayName:"硬币节点"})
    specie:cc.Node = null;

    @property({type:cc.Node,displayName:"mask节点"})
    maskNode:cc.Node = null;

    @property({type:cc.Node,displayName:"海神节点"})
    seaGod:cc.Node = null;
    @property(cc.Prefab)
    eggSurprisePrefab : cc.Prefab = null;
    @property(spendMode)
    mGameLayer : spendMode = null;

    onLoad(){
        super.onLoad();
        this.node.on("touchend",this.onTouchEnd,this);
    }

    onTouchEnd(e:cc.Event.EventTouch){
        // 许愿井事件
        if(this.clickCount >=10)return;
        O1HD.getManagers().soundMgr.playSound("wave").then();
        console.log("点击")
        this.clickCount ++;
        this.onClickWishWell();
    }

    initObj(){
        this.clickCount = 0;
        this.seaGod.y = -100;
    }

    onClickWishWell(){
        let coin = cc.instantiate(this.specie);
        coin.setParent(this.maskNode);
        cc.tween(coin).to(.5,{y:-60}).start();
        this.scheduleOnce(()=>{
            coin.destroy();
            coin.removeFromParent();
            //TODO 扣钱
        },2);
        if(this.clickCount >=10){
            cc.tween(this.seaGod).to(.5,{y:0}).start();
            this.scheduleOnce(()=>{
                // 触发海神事件
                let eggSurpriseNode = cc.instantiate( this.eggSurprisePrefab );
                eggSurpriseNode.getComponent( EggSurpise ).bindEvent( "seaGod" , this.mGameLayer );
                this.mGameLayer.uiNode.addChild( eggSurpriseNode );
            },.5);
        }
    }



}
